<mat-list>

    @if (vm.showDashboardLink) {
    <mce-navigation-item [icon]="'dashboard'" [text]="'Dashboard'" [routePath]="'/dashboard'">
    </mce-navigation-item> }

    @if (vm.showProjectsLink){
    <mce-navigation-item
        [icon]="'work_outline'" [text]="'Projects'" [routePath]="'/projects'">
    </mce-navigation-item> }

    <mat-divider></mat-divider>

    @if (vm.showSiteAdminLink){
    <mce-navigation-item [icon]="'build'" [text]="'Site Admin'" [routePath]="'/administration'">
    </mce-navigation-item>}

    <mat-divider></mat-divider>

    @if (vm.showAppHelpLink){
    <mce-navigation-item [icon]="'help_outline'" [text]="'Help/Support'" [routePath]="'/help'">
    </mce-navigation-item>}

    @if (vm.showMyCableEngineeringLink){
    <mce-navigation-item [icon]="'exit_to_app'" [text]="'myCableEngineering'" [externalPath]="'https://mycableengineering.com'">
    </mce-navigation-item>}

</mat-list>
